<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>

<app-header-bar
  id="header"
  [title]="clientDetails?.preferredFullName ?? ''"
  [showDate]="false"
  [showClientDetails]="false"
  [showButton]="false"
  [age]="age"
  [dob]="dob"
  *ngIf="clientDetails"
/>

<ng-container *ngIf="clientDetails">
  <!-- Client Information -->
  <div class="dashboard-side-card-container">
    <app-client-information
      [title]="'SERVICE_PLAN.CLIENT_INFO.TITLE' | translate"
      [attributes]="clientInformationAttributes"
      [isVertialOrientation]="true"
    />
  </div>

  <!-- Sub-Menu — same page chrome as every other client-scoped tool screen -->
  <app-sub-menu
    [clientId]="clientId"
    [totalReviews]="_totalReviews"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [servicePlanHasAccess]="true"
    [showBackButton]="true"
    (navigateBackClick)="goToDashboard()"
  />
</ng-container>

<div class="sr-only" aria-live="polite" aria-atomic="true">
  {{ announcer.message$ | async }}
</div>

<div class="service-plan-stepper-container" *ngIf="clientDetails">
  <div class="service-plan-stepper-side">
    <app-service-plan-step-rail
      [steps]="visibleSteps"
      [currentStepId]="currentStepId"
      [maxReachedIndex]="maxReachedIndex"
      (stepSelected)="onStepSelected($event)"
    />
  </div>

  <div class="service-plan-stepper-main">
    <h2 #stepHeading tabindex="-1" class="service-plan-stepper-step-title">
      {{
        'SERVICE_PLAN.STEP_INDICATOR'
          | translate
            : {
                current: currentStepNumber,
                total: visibleSteps.length,
                title: (currentStepTitleKey | translate)
              }
      }}
    </h2>

    <app-error-summary
      [titleKey]="'SERVICE_PLAN.ERROR_SUMMARY.TITLE'"
      [errors]="errors"
    />

    <app-service-plan-plan-type-step
      #activeStep
      *ngIf="currentStepId === 'planType'; else ndisPlanTpl"
    />
    <ng-template #ndisPlanTpl>
      <app-service-plan-ndis-plan-step
        #activeStep
        *ngIf="currentStepId === 'ndisPlan'; else ndisClassificationTpl"
        [ndisNumber]="clientDetails?.ndisNumber"
      />
    </ng-template>
    <ng-template #ndisClassificationTpl>
      <app-service-plan-ndis-classification-step
        #activeStep
        *ngIf="currentStepId === 'ndisClassification'; else baselinePackageTpl"
      />
    </ng-template>
    <ng-template #baselinePackageTpl>
      <app-service-plan-baseline-package-step
        #activeStep
        *ngIf="currentStepId === 'baselinePackage'; else familyGoalsTpl"
      />
    </ng-template>
    <ng-template #familyGoalsTpl>
      <app-service-plan-family-goals-step
        #activeStep
        *ngIf="currentStepId === 'familyGoals'; else hearingLanguageSupportTpl"
      />
    </ng-template>
    <ng-template #hearingLanguageSupportTpl>
      <app-service-plan-hearing-language-support-step
        #activeStep
        *ngIf="
          currentStepId === 'hearingLanguageSupport';
          else additionalServicesTpl
        "
      />
    </ng-template>
    <ng-template #additionalServicesTpl>
      <app-service-plan-additional-services-step
        #activeStep
        *ngIf="currentStepId === 'additionalServices'; else cfssTpl"
        [clientAgeYears]="clientAgeYears"
      />
    </ng-template>
    <ng-template #cfssTpl>
      <app-service-plan-support-block-step
        #activeStep
        *ngIf="currentStepId === 'cfss'; else audiologyTpl"
        blockKey="cfss"
        introKey="SERVICE_PLAN.STEP.CFSS.INTRO"
        timingLabelKey="SERVICE_PLAN.STEP.CFSS.TIMING_LABEL"
      />
    </ng-template>
    <ng-template #audiologyTpl>
      <app-service-plan-support-block-step
        #activeStep
        *ngIf="currentStepId === 'audiology'; else continuityPlanningTpl"
        blockKey="audiology"
        introKey="SERVICE_PLAN.STEP.AUDIOLOGY.INTRO"
        noteKey="SERVICE_PLAN.STEP.AUDIOLOGY.NOTE"
        timingLabelKey="SERVICE_PLAN.STEP.AUDIOLOGY.TIMING_LABEL"
      />
    </ng-template>
    <ng-template #continuityPlanningTpl>
      <app-service-plan-continuity-planning-step
        #activeStep
        *ngIf="currentStepId === 'continuityPlanning'; else reviewTpl"
      />
    </ng-template>
    <ng-template #reviewTpl>
      <app-service-plan-review-send-step
        #activeStep
        *ngIf="currentStepId === 'review'; else placeholderTpl"
        [clientId]="clientId"
        [clientDetails]="clientDetails"
      />
    </ng-template>
    <ng-template #placeholderTpl>
      <app-service-plan-step-placeholder [titleKey]="currentStepTitleKey" />
    </ng-template>

    <div class="service-plan-stepper-nav">
      <app-action-button
        kind="outline"
        color="primary"
        size="standard"
        (onClick)="onBack()"
      >
        {{ 'Back' | translate }}
      </app-action-button>
      <app-action-button
        *ngIf="!isPlaceholderStep && currentStepId !== 'review'"
        kind="filled"
        color="primary"
        size="standard"
        [isDisabled]="isContinueDisabled"
        (onClick)="onContinue()"
      >
        {{ 'SERVICE_PLAN.NAV.CONTINUE' | translate }}
      </app-action-button>
    </div>
  </div>
</div>
